// istanbul ignore file  # Not needed to test this file

import { createRemoteModule } from '@makemydeal/dr-shared-components';
import type { FunctionComponent } from 'react';
import type { CustomerEditInterface } from './types/CustomerEditInterface';

export const CustomerEditModule: FunctionComponent<CustomerEditInterface> = createRemoteModule<CustomerEditInterface>(
    'customer',
    './CustomerEditModule'
);
